import React from 'react'

// ─────────────────────────────────────────────────────────────────────────────
// SegmentedControl , full-width row of equal-sized buttons. One active.
//
//   <SegmentedControl
//     value={qType}
//     onChange={setQType}
//     options={[
//       { value: 'vote', label: 'Abstimmung', icon: ListChecks },
//       { value: 'text', label: 'Freitext', icon: MessageSquare },
//     ]}
//   />
// ─────────────────────────────────────────────────────────────────────────────

export function SegmentedControl({ value, onChange, options, className = '' }) {
  return (
    <div className={'flex w-full gap-1.5 ' + className}>
      {options.map(opt => {
        const Icon = opt.icon
        const on = value === opt.value
        return (
          <button
            key={opt.value}
            type="button"
            onClick={() => onChange && onChange(opt.value)}
            className={
              'flex-1 inline-flex items-center justify-center gap-1.5 px-3 py-2 rounded-[9px] ' +
              'text-[12.5px] whitespace-nowrap transition-colors ' +
              (on
                ? 'bg-[#fff1e8] border border-[rgba(232,93,31,0.30)] text-[#7a2b08] font-semibold'
                : 'bg-white border border-[#e7e5df] text-[#3a3733] font-medium hover:bg-[#f5f4f0] hover:border-[#d6d3cb] hover:text-[#1a1816]')
            }
          >
            {Icon && <Icon size={13}/>}
            {opt.label}
          </button>
        )
      })}
    </div>
  )
}
